import { NatsConnection } from 'nats.ws'
import { Dispatch, createContext, useReducer } from 'react'
import useNatsConnection from '@/components/Stocks/LivePrices/useNatsConnection'
import { WithChildren } from '@/root/types/utilities'

const initState: IState = {
  nats: undefined,
  reOpenConnectionCount: 0,
}
export const StocksNatsConnect = createContext<IState>(initState)
export const StocksNatsDispatchConnect = createContext<Dispatch<Action>>(
  {} as Dispatch<Action>,
)

interface IState {
  nats: NatsConnection | undefined
  reOpenConnectionCount: number
}

function reducer(state: IState, action: Action) {
  switch (action.type) {
    case 'UPDATE_NATS_CONNECTION': {
      return {
        ...state,
        nats: action.payload.nats,
      }
    }
    case 'UPDATE_REOPEN_CONNECTION_COUNT': {
      return {
        ...state,
        reOpenConnectionCount: state.reOpenConnectionCount + 1,
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action}`)
    }
  }
}
type Action =
  | {
      type: 'UPDATE_NATS_CONNECTION'
      payload: {
        nats: NatsConnection | undefined
      }
    }
  | {
      type: 'UPDATE_REOPEN_CONNECTION_COUNT'
      payload?: {
        reOpenConnectionCount: number
      }
    }

const NatsProvider = ({
  children,
  platform,
  authorization,
}: WithChildren<{ platform?: string; authorization?: string }>) => {
  const [state, dispatch] = useReducer(reducer, initState)
  const setConnect = nats => {
    dispatch({
      type: 'UPDATE_NATS_CONNECTION',
      payload: { nats },
    })
  }
  useNatsConnection(setConnect, platform, authorization, state)
  return (
    <StocksNatsDispatchConnect.Provider value={dispatch}>
      <StocksNatsConnect.Provider value={state}>
        {children}
      </StocksNatsConnect.Provider>
    </StocksNatsDispatchConnect.Provider>
  )
}
export default NatsProvider
